import { useState, useEffect } from 'react';
import { screenWidths } from '../enums/screen-width';

export const useMedia = screenSize => {
	let [view, setView] = useState(true);

	let mql = window.matchMedia(`(min-width:${screenWidths[screenSize]})`);

	const resizeHandler = () => {
		setView(mql.matches);
	};

	useEffect(() => {
		resizeHandler();
		if (mql.addEventListener) {
			mql.addEventListener('change', resizeHandler);
		} else {
			mql.addListener(resizeHandler);
		}
		return () => {
			mql.removeEventListener('change', resizeHandler);
			mql.removeListener(resizeHandler);
		};
	}, []);
	return view;
};
